/* ============================================================
   MediNeeds home — interactions (hero slider, carousels,
   scroll reveal, count-up, image placeholder).
   Markup is rendered by the Liquid sections; this only wires
   behaviour. Guarded so multiple section includes are safe.
   ============================================================ */
(function () {
  'use strict';
  if (window.__MN_HOME_INIT__) return;
  window.__MN_HOME_INIT__ = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Image placeholder — for <img onerror> when a set image fails to load */
  function placeholder(img) {
    var slot = img.closest('.img-slot');
    if (!slot) return;
    slot.classList.add('is-missing');
    if (slot.querySelector('.ph-label')) return;
    var label = slot.getAttribute('data-label') || img.alt || 'Image';
    var dim = slot.getAttribute('data-dim');
    var el = document.createElement('span');
    el.className = 'ph-label';
    el.innerHTML = label + (dim ? '<small>' + dim + '</small>' : '');
    slot.appendChild(el);
  }
  window.MN = { placeholder: placeholder };

  /* Hero slideshow — one per .mn-hero */
  function initHero(hero) {
    var slides = [].slice.call(hero.querySelectorAll('.slide'));
    var dots = [].slice.call(hero.querySelectorAll('.hero-dots button'));
    var progress = hero.querySelector('.hero-progress');
    var prev = hero.querySelector('.hero-arrow.prev');
    var next = hero.querySelector('.hero-arrow.next');
    if (slides.length < 2) {
      if (progress) progress.style.display = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }
    var i = 0, timer = null;
    function runProgress() {
      if (!progress || REDUCE) return;
      progress.classList.remove('run'); void progress.offsetWidth; progress.classList.add('run');
    }
    function go(n) {
      slides[i].classList.remove('active'); if (dots[i]) dots[i].classList.remove('active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('active'); if (dots[i]) dots[i].classList.add('active');
      runProgress();
    }
    function nextSlide() { go(i + 1); }
    function start() { if (REDUCE) return; stop(); timer = setInterval(nextSlide, 6000); runProgress(); }
    function stop() { if (timer) clearInterval(timer); }
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  }

  /* Horizontal carousels (bestsellers / spotlight) */
  function initCarousels() {
    document.querySelectorAll('.carousel-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var carousel = btn.closest('.carousel');
        var track = carousel && carousel.querySelector('.carousel-track');
        if (!track) return;
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.85), behavior: 'smooth' });
      });
    });
  }

  /* Scroll reveal + staggered groups */
  function initReveal() {
    var items = [].slice.call(document.querySelectorAll('.reveal, .reveal-group'));
    if (!items.length) return;
    if (REDUCE || !('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('in'); }); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        if (t.classList.contains('reveal-group')) {
          [].slice.call(t.children).forEach(function (c, idx) { c.style.transitionDelay = Math.min(idx * 55, 420) + 'ms'; });
        }
        t.classList.add('in');
        obs.unobserve(t);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (i) { obs.observe(i); });
  }

  /* Count-up numbers */
  function initCountUp() {
    var els = [].slice.call(document.querySelectorAll('[data-count]'));
    if (!els.length) return;
    var fmt = function (n) { return n.toLocaleString('en-IN'); };
    function run(node) {
      var target = parseInt(node.getAttribute('data-count'), 10) || 0;
      var suffix = node.getAttribute('data-suffix') || '';
      if (REDUCE) { node.textContent = fmt(target) + suffix; return; }
      var startT = null, dur = 1500;
      function step(t) {
        if (!startT) startT = t;
        var p = Math.min((t - startT) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        node.textContent = fmt(Math.round(target * eased)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (n) { obs.observe(n); });
  }

  /* ---- Mobile menu drawer ----
     Relocation + toggle live here (external asset) instead of an inline section
     <script>, so the menu works reliably even where inline scripts are blocked
     by an app CSP or run out of order. Delegated handlers are attached once. */
  function initDrawer() {
    var dr = document.getElementById('mnDrawer'),
        bd = document.getElementById('mnDrawerBackdrop');
    if (!dr || !bd || dr.dataset.mnRelocated) return;
    // Move drawer + backdrop to a body-level .mn-scope wrapper so a transformed
    // theme ancestor can't trap their fixed positioning.
    var host = document.querySelector('.mn-scope.mn-drawer-host');
    if (!host) { host = document.createElement('div'); host.className = 'mn-scope mn-drawer-host'; document.body.appendChild(host); }
    host.appendChild(bd); host.appendChild(dr);
    dr.dataset.mnRelocated = '1';
  }
  function setDrawer(openIt) {
    var dr = document.getElementById('mnDrawer'),
        bd = document.getElementById('mnDrawerBackdrop'),
        btn = document.getElementById('mnMenuBtn');
    if (!dr || !bd) return;
    dr.classList.toggle('open', openIt);
    bd.classList.toggle('open', openIt);
    if (btn) btn.setAttribute('aria-expanded', openIt ? 'true' : 'false');
    document.documentElement.style.overflow = openIt ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    if (el.closest('#mnMenuBtn')) {
      e.preventDefault();
      var dr = document.getElementById('mnDrawer');
      setDrawer(!(dr && dr.classList.contains('open')));
    } else if (el.closest('#mnDrawerBackdrop') || el.closest('#mnDrawerClose')) {
      setDrawer(false);
    } else if (el.closest('#mnDrawer a')) {
      setDrawer(false);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---- Product page (PDP) interactions ----
     Runs from this external asset (already loaded on every page) instead of an inline
     section <script>, so gallery / quantity / variants / pincode work reliably even
     where inline scripts are blocked. Per-product data comes from a CSP-safe JSON
     island: <script type="application/json" class="mn-pdp-data">. No-op off the PDP. */
  function initPDP(root) {
    if (!root || root.dataset.mnInit) return;
    root.dataset.mnInit = '1';
    /* The JSON data island only ENRICHES variant switching (id/price/availability).
       Gallery, quantity, pincode, tabs and add-to-cart are wired straight from the DOM
       below, so the PDP keeps working even if the island is missing, blocked (app CSP)
       or unparseable. Never gate the whole PDP on parsing that island. */
    var VARIANTS = [], cartUrl = '/cart', cartAddUrl = '/cart/add';
    var island = document.querySelector('script.mn-pdp-data[type="application/json"]');
    if (island) {
      try {
        var data = JSON.parse(island.textContent);
        VARIANTS = data.variants || [];
        cartUrl = data.cartUrl || cartUrl;
        cartAddUrl = data.cartAddUrl || cartAddUrl;
      } catch (e) { /* fall back to DOM-only behaviour */ }
    }
    var form = root.querySelector('#mnProductForm');
    var stage = root.querySelector('#mnStageImg');
    var idInput = root.querySelector('#mnVariantId');

    /* Gallery: thumbnail → main image */
    root.querySelectorAll('[data-full]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (stage) stage.src = b.getAttribute('data-full');
        var group = b.parentNode;
        group.querySelectorAll('[data-full]').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });

    /* Quantity stepper */
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = root.querySelector('#mnQty'); if (!q) return;
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    /* Variants */
    var selected = [];
    root.querySelectorAll('.pdp-variant-group').forEach(function (g, gi) {
      var a = g.querySelector('.pdp-swatch.active') || g.querySelector('.pdp-swatch');
      selected[gi] = a ? a.getAttribute('data-value') : null;
    });
    function fmt(el, val, show) { if (!el) return; if (show) { el.hidden = false; el.textContent = val; } else el.hidden = true; }
    function updateVariant() {
      if (!VARIANTS.length) return;
      var v = VARIANTS.find(function (x) { for (var i = 0; i < selected.length; i++) { if (x.options[i] !== selected[i]) return false; } return true; }) || VARIANTS[0];
      if (idInput) idInput.value = v.id;
      var pe = root.querySelector('#mnPrice'); if (pe) pe.textContent = v.price;
      fmt(root.querySelector('#mnCompare'), v.compare, v.has_compare);
      var oe = root.querySelector('#mnOff'); if (oe) { if (v.has_compare) { oe.hidden = false; oe.textContent = v.pct + '% OFF'; } else oe.hidden = true; }
      var se = root.querySelector('#mnSave'); if (se) { if (v.has_compare) { se.hidden = false; se.textContent = 'You save ' + v.save; } else se.hidden = true; }
      var sp = root.querySelector('#mnStickyPrice'); if (sp) sp.textContent = v.price;
      var ab = root.querySelector('#mnAddBtn'), al = root.querySelector('#mnAddLabel');
      if (ab) { ab.disabled = !v.available; if (al) al.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.img && stage) stage.src = v.img;
    }
    root.querySelectorAll('.pdp-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = parseInt(sw.getAttribute('data-option-index'), 10);
        selected[idx] = sw.getAttribute('data-value');
        sw.parentNode.querySelectorAll('.pdp-swatch').forEach(function (x) { x.classList.remove('active'); });
        sw.classList.add('active');
        updateVariant();
      });
    });

    /* AJAX add to cart */
    var toast = root.querySelector('#mnToast'), tT;
    function showToast() { if (!toast) return; toast.classList.add('show'); clearTimeout(tT); tT = setTimeout(function () { toast.classList.remove('show'); }, 2500); }
    function refreshCount() {
      fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = false; });
      }).catch(function () {});
    }
    function addToCart() {
      if (!form) return Promise.reject();
      var fd = new FormData(form); var ab = root.querySelector('#mnAddBtn'); if (ab) ab.disabled = true;
      return fetch(cartAddUrl + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { showToast(); refreshCount(); if (ab) ab.disabled = false; });
    }
    if (form) form.addEventListener('submit', function (e) { if (e.submitter && e.submitter.name === 'add') { e.preventDefault(); addToCart().catch(function () { form.submit(); }); } });
    var sAdd = root.querySelector('#mnStickyAdd'), sBuy = root.querySelector('#mnStickyBuy');
    if (sAdd) sAdd.addEventListener('click', function () { addToCart().catch(function () { if (form) form.submit(); }); });
    if (sBuy) sBuy.addEventListener('click', function () { addToCart().then(function () { window.location.href = '/checkout'; }).catch(function () { if (form) form.submit(); }); });

    /* Pincode delivery check (pan-India) */
    var pinWrap = root.querySelector('.pdp-pincode');
    if (pinWrap) {
      var pinInput = pinWrap.querySelector('input');
      var pinBtn = pinWrap.querySelector('button');
      var msg = root.querySelector('.pdp-pin-msg');
      if (!msg) { msg = document.createElement('div'); msg.className = 'pdp-pin-msg'; msg.setAttribute('role', 'status'); pinWrap.parentNode.insertBefore(msg, pinWrap.nextSibling); }
      var okIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>';
      var errIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"/></svg>';
      var checkPin = function () {
        var val = (pinInput && pinInput.value || '').replace(/\D/g, '');
        if (/^[1-9][0-9]{5}$/.test(val)) {
          msg.className = 'pdp-pin-msg ok';
          msg.innerHTML = okIcon + '<span>Yes! Delivery is available at <b>' + val + '</b> — your location is eligible for pan-India delivery.</span>';
        } else {
          msg.className = 'pdp-pin-msg err';
          msg.innerHTML = errIcon + '<span>Please enter a valid 6-digit pincode.</span>';
        }
      };
      if (pinBtn) pinBtn.addEventListener('click', checkPin);
      if (pinInput) {
        pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });
        pinInput.addEventListener('input', function () { pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6); });
      }
    }

    /* Tab scroll-spy */
    var links = root.querySelectorAll('.pdp-tablink');
    if (links.length) {
      var secs = []; links.forEach(function (l) { var t = document.getElementById(l.getAttribute('href').slice(1)); if (t) secs.push(t); });
      if ('IntersectionObserver' in window && secs.length) {
        var obs = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('active', l.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-140px 0px -60% 0px', threshold: 0 });
        secs.forEach(function (x) { obs.observe(x); });
      }
      links.forEach(function (l) { l.addEventListener('click', function (e) { var t = document.getElementById(l.getAttribute('href').slice(1)); if (t) { e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' }); } }); });
    }

    updateVariant();
  }
  function initProductPages() {
    /* Find the PDP by its container (not by the data island), so wiring runs even when
       the island is stripped/blocked by an app. The island is read inside initPDP. */
    var roots = document.querySelectorAll('.mn-pdp');
    if (roots.length) { [].forEach.call(roots, initPDP); return; }
    var f = document.getElementById('mnProductForm');
    if (f) initPDP(f.closest('.mn-scope') || document.body);
  }

  /* Reveal-on-scroll header (Dawn/Shopify-style): the header section is position:sticky;
     here we HIDE it (translate up, via the .mn-hidden class) when scrolling DOWN and show
     it again when scrolling UP. Always shown near the very top. Runs from this external
     asset so it works even where inline section scripts are blocked. */
  function initStickyHeader() {
    var header = document.getElementById('mnHeader');
    if (!header) return;
    var sec = header.closest('.mn-header-section') || header.closest('.shopify-section');
    if (!sec || sec.dataset.mnReveal) return;
    sec.dataset.mnReveal = '1';
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y <= 100) { sec.classList.remove('mn-hidden'); }             // near the top → always show
      else if (y > lastY + 4) { sec.classList.add('mn-hidden'); }      // scrolling down → hide
      else if (y < lastY - 4) { sec.classList.remove('mn-hidden'); }   // scrolling up → show
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function init() {
    initDrawer();
    initStickyHeader();
    initProductPages();
    document.querySelectorAll('.mn-hero').forEach(initHero);
    initCarousels();
    initReveal();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init in the Shopify theme editor when a section is added/reordered
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var hero = e.target.querySelector && e.target.querySelector('.mn-hero');
      if (hero) initHero(hero);
      initDrawer(); initStickyHeader(); initProductPages(); initCarousels(); initReveal(); initCountUp();
    });
  }
})();
